import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  TableRow,
  Checkbox,
  TableBody,
  TableHead,
  TableCell,
  withStyles,
  TableSortLabel,
} from '@material-ui/core'

import Automation from './Automation'


const styles = theme => ({
  root: {
    marginTop: theme.spacing(2),
  },
  disableMargin: {
    marginTop: 0,
  },
})


class TableAutomation extends PureComponent {
  /* LIFECYCLE */

  /* METHODS */

  /**
   * On click on an item
   * @param {*} item - The item selected
   */
  handleClick = item => (e) => {
    const { onClick } = this.props

    if (onClick) {
      onClick(item, e)
    }
  }

  handleSortChange = nextSort => () => {
    const { sort, onSortChange } = this.props

    if (!sort.includes(nextSort)) {
      return onSortChange(`${nextSort}_desc`)
    }

    const direction = sort.includes('_asc') ? '_desc' : '_asc'

    return onSortChange(`${nextSort}${direction}`)
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      row,
      head,
      sort,
      items,
      classes,
      onClick,
      selected,
      isLoading,
      className,
      selectable,
      onSelectAll,
      onSortChange,
      ...props
    } = this.props

    return (
      <Automation
        {...props}
        row={row}
        head={head}
        items={items}
        isLoading={isLoading}
      >
        <Table>
          <TableHead>
            <TableRow>
              {selectable && (
                <TableCell padding="checkbox">
                  <Checkbox
                    onChange={onSelectAll}
                    inputProps={{ 'aria-label': 'select all' }}
                    checked={items.length > 0 && items.length === selected.length}
                    indeterminate={selected.length > 0 && selected.length < items.length}
                  />
                </TableCell>
              )}
              {head.map((cell) => {
                if (!cell.sort) {
                  return (
                    <TableCell key={cell}>
                      {cell}
                    </TableCell>
                  )
                }

                const sortDirection = sort.includes(cell.sort) && sort.includes('desc') ? 'asc' : 'desc'
                return (
                  <TableCell key={cell.label} sortDirection={sortDirection}>
                    <TableSortLabel
                      direction={sortDirection}
                      active={sort.includes(cell.sort)}
                      onClick={this.handleSortChange(cell.sort)}
                    >
                      {cell.label}
                    </TableSortLabel>
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((item) => {
              let role
              const values = row(item)
              const isSelected = selected.includes(item.objectID)

              if (selectable) {
                role = 'checkbox'
              } else if (onClick) {
                role = 'button'
              }

              return (
                <TableRow
                  role={role}
                  key={item.objectID}
                  selected={isSelected}
                  hover={!!onClick || selectable}
                  onClick={this.handleClick(item)}
                >
                  {selectable && (
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isSelected}
                        inputProps={{ 'aria-labelledby': item.objectID }}
                      />
                    </TableCell>
                  )}
                  {values.map((value, idx) => {
                    const currentHead = head[idx]

                    return (
                      <TableCell key={`${item.objectID}-${currentHead.label || currentHead}-${idx}`}>
                        {typeof value === 'object' ? value.display : value}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Automation>
    )
  }
}


TableAutomation.defaultProps = {
  row: [],
  sort: '',
  head: [],
  items: [],
  selected: [],
  onSelectAll: () => {},
  onSortChange: () => {},
}


TableAutomation.propTypes = {
  onClick: PropTypes.func,
  sort: PropTypes.string,
  count: PropTypes.number,
  hasMore: PropTypes.bool,
  isLoading: PropTypes.bool,
  selectable: PropTypes.bool,
  csvTitle: PropTypes.string,
  hasPrevious: PropTypes.bool,
  className: PropTypes.string,
  onSelectAll: PropTypes.func,
  onSortChange: PropTypes.func,
  disableMargin: PropTypes.bool,
  request: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.arrayOf(PropTypes.string),
  head: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
  row: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object]))]),
}


export default withStyles(styles)(TableAutomation)
